import classNames from 'classnames';
import React, { FC } from 'react';

import { formatDuration } from '../../utils/date';

import './WarningTimer.scss';

export enum WarningTheme {
  WARNING_ONE = 'warning-one',
  WARNING_TWO = 'warning-two',
  OVERDUE = 'overdue',
}

interface Props {
  time: number;
  color: string;
  blink?: boolean;
}

const WarningTimer: FC<Props> = ({ time, color, blink }) => {
  const classes = blink ? classNames('warning-timer', { blink: time <= 0 }) : classNames('warning-timer');

  return (
    <div
      className={classes}
      style={{
        backgroundColor: color,
      }}>
      {<p className='text-warning'>{formatDuration(time)}</p>}
    </div>
  );
};

export default WarningTimer;
